import { render } from "./Integration.vue?vue&type=template&id=289d93a9&ts=true"
import script from "./Integration.vue?vue&type=script&lang=ts"
export * from "./Integration.vue?vue&type=script&lang=ts"

import "./Integration.vue?vue&type=style&index=0&id=289d93a9&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__